export default function (separator: string = '-'): string {
    const { $i18n } = useNuxtApp()
    const { locale } = $i18n

    return `${locale.value}${separator}${locale.value === 'en' ? 'GB' : locale.value.toUpperCase()}`
}
